import { SsoLinkCode, SsoType, SsoTypeString } from '@diritto/common/account/constants/sso.constant';
import { AccountApi } from 'api/ApiHelper';
import axios, { AxiosError } from 'axios';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useCallback } from 'react';

export const useSsoLink = () =>
  useCallback(async (ssoType: SsoType, ssoAccessToken: string) => {
    let code = SsoLinkCode.Unknown;
    try {
      await AccountApi.linkSso(ssoType, { ssoAccessToken });
      code = SsoLinkCode.Success;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        const data = (
          e as AxiosError<{
            code: SsoLinkCode;
            ssoType: SsoType;
          }>
        ).response?.data;

        if (data?.code) {
          code = data.code;
        }
      }
    } finally {
      switch (code) {
        case SsoLinkCode.Success:
          DirittoAppBridge.showToast(`${SsoTypeString[ssoType]} SNS 계정이 연결되었어요.`);
          break;
        case SsoLinkCode.AlreadyLinked:
          DirittoAppBridge.showToast(
            `해당 ${SsoTypeString[ssoType]} 계정은 다른 디리토 계정에 연결되어 있어 연결할 수 없어요.`,
          );
          break;
        case SsoLinkCode.NotYetUnlinkTermination:
          DirittoAppBridge.showToast(
            `해당 ${SsoTypeString[ssoType]} 계정은 연결 해제 후 30일이 지나지 않아서 연결할 수 없어요.`,
          );
          break;
        case SsoLinkCode.NotAuthorized:
          DirittoAppBridge.showToast('인증 정보가 없어요. 다시 시도해주세요. 문제가 지속되면 고객센터에 문의해주세요.');
          break;
        case SsoLinkCode.Unknown:
        default:
          DirittoAppBridge.showToast(
            '정상적으로 처리되지 않았어요. 다시 시도해주세요. 문제가 지속되면 고객센터에 문의해주세요.',
          );
      }

      DirittoAppBridge.completeSign();
    }
  }, []);
